import { cn } from 'cn';
import { memo, type ReactNode } from 'react';
import { ParagraphWrapper } from '~/atoms/ParagraphWrapper';

import { EmptyStateIllustration } from './EmptyStateIllustration';

type P = {
  CallToAction?: ReactNode;
  heading?: string;
  hint: string | string[];
  Illustration?: ReactNode | undefined;
} & ComponentStyling;

export const EmptyState = memo<P>(
  ({
    CallToAction = null,
    Illustration = <EmptyStateIllustration />,
    className,
    heading,
    hint,
    style,
    ...rest
  }) => (
    <div
      {...rest}
      className={cn(
        'mx-auto flex size-full max-h-96 max-w-lg flex-col items-center justify-center gap-y-2 p-4 text-center',
        className,
      )}
      style={style}
    >
      {Illustration}
      {heading ? (
        <h2 className="text-xl text-tiga-text-lightest">{heading}</h2>
      ) : null}
      <div className="text-sm text-tiga-text-lighter">
        {Array.isArray(hint) ? (
          <ParagraphWrapper paragraphs={hint} wrapIn="div" />
        ) : (
          hint
        )}
      </div>
      {CallToAction}
    </div>
  ),
);

EmptyState.displayName = 'EmptyState';
